<div class="bed-bath-container" [ngClass]="{ mobile: isMobile() }" (clickOutside)="closeDropdown()">
  <div class="input" (click)="toggleDropdown()">
    <div>
      <span class="title ml-5 mr-5">More</span>
      <span class="selected-amount ml-10">({{ numberOfSelected$ | async }})</span>
    </div>
    <fa-icon class="ml-15" [class]="{ flip: isOpen }" icon="angle-down" />
  </div>

  @if (isOpen) {
    <div class="options-container">
      <div class="options pb-3">
        <form [formGroup]="moreFormGroup">
          <p class="mb-2 section-header">{{ labels.SECTIONS.PURCHASE }}</p>
          <div formArrayName="FINANCING">
            @for (control of financingControls; track control; let i = $index; let isLast = $last) {
              <div [ngClass]="{ 'mb-4': isLast, 'mb-2': !isLast }">
                <app-input-checkbox
                  [label]="labels.FINANCING[i]"
                  [formControlName]="i" />
              </div>
            }
          </div>

          <p class="mb-2 section-header">{{ labels.SECTIONS.OCCUPANCY }}</p>
          <div formArrayName="OCCUPANCY">
            @for (control of occupancyControls; track control; let i = $index; let isLast = $last) {
              <div [ngClass]="{ 'mb-4': isLast, 'mb-2': !isLast }">
                <app-input-checkbox
                  [label]="labels.OCCUPANCY[i]"
                  [formControlName]="i" />
              </div>
            }
          </div>

          <p class="mb-2 section-header">{{ labels.SECTIONS.ADDITIONAL }}</p>
          <div class="mb-2">
            <app-input-checkbox
              [label]="labels.ADDITIONAL.RESERVEMET"
              formControlName="RESERVEMET" />
          </div>
          <div class="mb-2">
            <app-input-checkbox
              [label]="labels.ADDITIONAL.ENDINGTODAY"
              formControlName="ENDINGTODAY" />
          </div>
          <div class="mb-2">
            <app-input-checkbox
              [label]="labels.ADDITIONAL.POSTAUCTIONS"
              formControlName="POSTAUCTIONS" />
          </div>
          <div class="mb-4">
            <app-input-checkbox
              [label]="labels.ADDITIONAL.NOBUYERPREMIUMS"
              formControlName="NOBUYERPREMIUMS" />
          </div>
        </form>
      </div>
    </div>
  }
</div>